export enum Action {
    Alert = 1,
    Raise = 2,
}
